import { Profile } from "@/components/profile/Profile";
import { Header } from "@/components/SiteUI";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ProfilePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("access_token")) {
      navigate("/auth");
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-olive-50">
      <Header />
      <Profile />
    </div>
  );
};
